/**
 * Checkout Tour Configuration
 *
 * Step-by-step tour for creating and managing checkout payment links.
 */

import { filterExistingSteps } from './tourUtils.js';

export const getCheckoutTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="checkout-header"]',
      content: t('tour.checkout.header', {
        ns: 'common',
        defaultValue: 'Create and manage secure checkout payment links for your customers.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="checkout-generate"]',
      content: t('tour.checkout.generate', {
        ns: 'common',
        defaultValue: 'Click here to generate a new checkout link with amount, customer details, and invoice items.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="checkout-filters"]',
      content: t('tour.checkout.filters', {
        ns: 'common',
        defaultValue: 'Filter your checkout history by date range. The default range covers the last two months.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="checkout-list"]',
      content: t('tour.checkout.list', {
        ns: 'common',
        defaultValue: 'View your checkout sessions here. Click a card to see details, copy the payment link, or review status.',
      }),
      position: 'top',
    },
    {
      selector: '[data-tour="checkout-pagination"]',
      content: t('tour.checkout.pagination', {
        ns: 'common',
        defaultValue: 'Navigate through older checkout sessions when you have multiple pages of results.',
      }),
      position: 'top',
    },
  ]);
